import { InputSelectProps } from "@dirootie-web/components-types";
import { ParameterTypeList } from "./types/parameter.type";
import { SelectSystemEnum } from "@components-common/forms";

/**
 * Functional Component: ParameterTypeSelector
 *
 * This component renders a dropdown selector for choosing a parameter type. It utilizes the `SelectSystemEnum` component
 * and provides a list of parameter types as options.
 *
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {boolean} [props.showHelp] - Optional flag to show help text.
 * @param {boolean} [props.showLabel] - Optional flag to show the label.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the parameter type selector dropdown.
 */
export const ParameterTypeSelector = (
  props: Omit<
    InputSelectProps & { showHelp?: boolean; showLabel?: boolean },
    "options" | "formState"
  >
) => <SelectSystemEnum {...props} items={ParameterTypeList as any} />;
